import React from 'react'
import { paneRects, type PaneLayout } from './splitLayout'

// A split layout drawn as itself — its panes as filled blocks in a 16:9
// frame — so the View menu's rows show the shape they pick, the three-pane
// triangle included, which no stock icon does. Locked layouts are drawn at
// 16:9 panels so the glyph stays solid rather than shrinking to the framing.
const W = 22
const H = 14
const GAP = 1.5

export default function LayoutGlyph({ layout, style }: { layout: PaneLayout; style?: React.CSSProperties }) {
  return (
    <svg width={W} height={H} viewBox={`0 0 ${W} ${H}`} style={style} aria-hidden>
      {paneRects(layout, W, H, 16 / 9).map((r, i) => (
        <rect
          key={i}
          x={r.x + GAP / 2}
          y={r.y + GAP / 2}
          width={r.width - GAP}
          height={r.height - GAP}
          rx={1}
          fill="currentColor"
        />
      ))}
    </svg>
  )
}
